<div class="modal-content">
  <form method="post" [formGroup]="importForm" enctype="multipart/form-data">
    <div class="modal-header">
      <h4>Vizsgázók importálása</h4>
    </div>
    <div class="modal-body">
      <div class="form-group mb-3">
        <label for="file">Fájl<span class="required-label">*</span></label>
        <input #fileInput type="file" id="file" class="form-control" formControlName="file" accept=".xlsx" />
        <div *ngIf="file.invalid && (file.dirty || file.touched)" class="alert alert-danger">
          <div *ngIf="file.errors?.['required']">A fájl kiválasztása kötelező.</div>
          <div *ngIf="file.errors?.['fileSize']">A fájl mérete túl nagy. Maximálisan megengedett méret: {{maxFileSizeMb}}MB</div>
          <div *ngIf="file.errors?.['serverError']">{{file.errors?.['serverError']}}</div>
        </div>
      </div>

      <div class="form-group mb-3">
        <div class="form-check">
          <input
            id="stopOnFirstError"
            type="checkbox"
            class="form-check-input"
            [checked]="stopOnFirstError.value"
            formControlName="stopOnFirstError"
          />
          <label
            for="stopOnFirstError"
            title="Bekapcsolt esetben a sikeres beolvasást követően az első adathibánál megáll a művelet."
          >
            Megállás első hibánál
          </label>
        </div>
      </div>

      <div class="form-group" *ngIf="errors && errors.length > 0">
        <hr />
        <label class="error-label">Hibák</label>
        <button type="button" class="btn btn-light" (click)="copyToClipboard(errors)">📋 Másolás</button>
        <div class="alert alert-danger alert-content">
          <div *ngFor="let error of errors">
            {{ error }}
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary text-white me-auto" (click)="downloadExampleFile()" [disabled]="isImporting">Mintafájl letöltése</button>
      <button type="button" class="btn btn-dark" (click)="close()">Mégse</button>
      <button type="button" class="btn btn-primary text-white" (click)="confirm()" [disabled]="importForm.invalid || isImporting">
        Importálás
      </button>
    </div>
  </form>
</div>
